<template>
  <BaseButton success class="w-full" :disabled="loading" @click="createPerson">
    New Person
  </BaseButton>
</template>

<script>
import { contactPersonClient } from '@/api/clients';
import { CONTACTS } from '@/store/entities/schema_types';

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async linkPersonWithContact(personId) {
      try {
        this.loading = true;

        const response = await contactPersonClient.update(this.contact.id, {
          person_id: personId,
        });

        await this.$store.dispatch('entities/persistEntities', {
          type: CONTACTS,
          data: response.data,
        });

        this.$emit('created', personId);
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    createPerson() {
      this.$modal.show({
        component: 'AccountPersonCreateModal',
        props: {
          accountId: this.contact.accountId,
          defaultData: {
            firstName: this.contact?.firstName || '',
            lastName: this.contact?.lastName || '',
            emailAddress: this.contact?.email || '',
            phoneNumber: this.contact?.phone || '',
          },
        },
        on: {
          created: (personId) => this.linkPersonWithContact(personId),
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
